export const time2minutes = (time: string): number => {
  if (!time) return 0;
  if (!isNaN(Number(time))) {
    return Number(time);
  }
  const timeNumbers = time.replace(/\D/g, "");
  if (timeNumbers.length < 4) return 0;
  const hours = parseInt(timeNumbers.slice(0, -2), 10);
  const minutes = parseInt(timeNumbers.slice(-2), 10);
  return hours * 60 + minutes;
};

export function hhmmToMinutes(time: string): number {
  if (!time) return 0;
  const [h, m] = time.split(":").map(Number);
  if (isNaN(h) || isNaN(m)) return 0;
  return h * 60 + m;
}

export function minutesToHHMM(minutes: number): string {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}`;
}
